// @ts-nocheck
import parse from 'html-react-parser';
import Storage from './storage/storage';
import { ProductType } from '../components/@types/product';
import { Trn } from '../translations/language';
import { parseURL } from '../routes/router';

export function synergetic({
  // @ts-ignore
  src,
  width = 500,
  height = 500,
  type = 'imageScaler',
}) {
  /*imageStretcher
  imageFiller
  imageFitter
  imageScaler*/
  return `${window.location.protocol}//${_MainDomain}/ARCSynergetic/?do=${type}&width=${width}&height=${height}&loc=${src}`;
}

export function setTitle(params: { title: string }) {
  const { title } = params;
  const elem = document.getElementById('headerTxt');
  if (elem) {
    elem.innerText = title;
  }
}

// @ts-ignore
export function compareOrdering(a, b) {
  if (parseFloat(a.ordering) < parseFloat(b.ordering)) {
    return -1;
  }
  if (parseFloat(a.ordering) > parseFloat(b.ordering)) {
    return 1;
  }
  return 0;
}
// @ts-ignore
export function compareOrderingASC(a, b) {
  if (parseFloat(a.ordering) < parseFloat(b.ordering)) {
    return 1;
  }
  if (parseFloat(a.ordering) > parseFloat(b.ordering)) {
    return -1;
  }
  return 0;
}

export function isEnglish(character: string) {
  const persian = /^[\u0600-\u06FF]+$/;
  return !persian.test(character);
}

export function getPrice(item: ProductType) {
  const { price, onWow, wowPrice } = item;

  if (onWow && onWow !== '0') {
    return wowPrice || price;
  }
  return price;
}

export function removeTag(text: string) {
  const regex = /(<([^>]+)>)/gi;
  return text.replace(regex, '');
}

export function jsonParse(input: string | object | undefined) {
  let output;
  try {
    output = JSON.parse(input);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    output = input;
  }
  return output;
}

export function getUrl(txt: string) {
  // @ts-ignore
  if (txt) {
    if (txt?.includes('http')) {
      return txt;
    }
    // @ts-ignore
    return `${_baseUrl}${txt}`;
  } else {
    return '';
  }
}

export function getLanguage() {
  const storeLang = Storage.getLanguage();
  let lang;
  if (!storeLang) {
    // eslint-disable-next-line
    lang = _DefaultLanguage;
    window.location.reload();
  } else {
    lang = storeLang;
  }
  return lang;
}

export function isValidEmail(email) {
  // Regular expression for a basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Test the email against the regular expression
  return emailRegex.test(email);
}

export function deepMerge(target, ...sources) {
  if (!sources.length) return target;

  const source = sources.shift();

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (
        source[key] instanceof Object &&
        source[key] !== null &&
        target[key] instanceof Object &&
        target[key] !== null
      ) {
        // Recursively merge objects
        target[key] = deepMerge(target[key], source[key]);
      } else {
        // Copy values for non-object properties
        target[key] = source[key];
      }
    }
  }

  // Continue to the next source
  return deepMerge(target, ...sources);
}

export function getFilterList(input) {
  const params = decodeURI(input);
  let newParams = params?.split('?')[1];
  let filters = {};
  if (params) {
    const list = newParams?.split('&');
    let object = {};
    for (let i in list) {
      let ignore = false;
      let accept = true;
      let [key, value] = list[i]?.split('=');
      if (key?.includes('!')) {
        key = key?.replace('!', '');
        ignore = true;
      }
      //alt+16->برای فیلتری که نباید حذف شود
      if (key?.includes('►')) {
        key = key?.replace('►', '');
        ignore = false;
      }
      //اگر : بعد از مساوی باشد نباید داخل لیست بیاید
      if (key?.includes(':')) {
        key = key?.replace(':', '');
        accept = false;
      }

      if (accept) {
        if (key?.includes('[')) {
          const array = key?.split('[');
          let originalKey = array[0];
          if (ignore) {
            originalKey = `!${originalKey}`;
          }
          array?.shift();
          // let object = { [originalKey]: {} };
          if (!object[originalKey]) {
            object[originalKey] = {};
          }
          const loopArray = [];
          for (let i = 0; i < array?.length; i++) {
            if (array[i]?.includes(']')) {
              const index = array[i].split(']')[0];
              if (i === 0) {
                if (array.length === 1) {
                  object[originalKey][index] = value;
                } else {
                  if (!object[originalKey][index]) {
                    object[originalKey][index] = {};
                  }
                }
                loopArray.push(index);
              } else {
                //todo:اینجا باید برای آرایه یا آبجکت چند بعدی لوپ بخوره
                // let temp = { ...object[originalKey] };
                // for (let j = 0; j < loopArray.length; j++) {
                //   temp = temp[loopArray[j]];
                // }
                // temp[index] = value;
                object[originalKey][loopArray[0]][index] = value;
              }
            }
          }
          filters = { ...filters, ...object };
        } else {
          if (ignore) {
            key = `!${key}`;
          }
          filters[key] = value;
        }
      }
    }
  }

  return filters;
}

export function isEqual(val1, val2) {
  if (typeof val1 === 'number' && typeof val2 === 'number') {
    return +val1 === +val2;
  }
  if (isNumeric(val1) && typeof val2 === 'number') {
    return +val1 === val2;
  }
  if (isNumeric(val2) && typeof val1 === 'number') {
    return val1 === +val2;
  }
  if (isNumeric(val1) && isNumeric(val2)) {
    return +val1 === +val2;
  }
  if (typeof val1 === 'string' && typeof val2 === 'string') {
    return val1.toLowerCase() === val2.toLowerCase();
  }
  if (typeof val1 === 'boolean' && typeof val2 === 'string') {
    return compareBooleanValues(val2, val1);
  }
  if (typeof val2 === 'boolean' && typeof val1 === 'string') {
    return compareBooleanValues(val1, val2);
  }
}

export function isInclude(list, item) {
  if (list && Array.isArray(list)) {
    let find = false;
    for (let i in list) {
      if (isNumeric(list[i]) && (typeof item === 'number' || isNumeric(item))) {
        find = +list[i] === +item;
        if (find) {
          break;
        }
      } else {
        return list?.includes(item);
      }
    }
    return find;
  }
}

export function isNumeric(str) {
  if (typeof str != 'string') {
    return false;
  }
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export function persianToEnglish(input) {
  if (input) {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    let result = '';
    for (let i = 0; i < input.length; i++) {
      const index = persianNumbers.indexOf(input[i]);
      if (index !== -1) {
        result += englishNumbers[index];
      } else {
        result += input[i];
      }
    }
    return result;
  }
  return '';
}

export function isPersianNumber(number) {
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return persianNumbers.includes(number);
}

export function isNumber(number) {
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return persianNumbers.includes(number) || /^[0-9]$/i.test(number);
}

export function hasValue(item) {
  if (Array.isArray(item)) {
    return !!item.length;
  }
  if (item && typeof item === 'object') {
    return !!Object.keys(item).length;
  }
  if (typeof item === 'string') {
    return !!item;
  }
  if (typeof item === 'number') {
    if (item === 0) {
      return true;
    } else {
      return !!item;
    }
  }
  return !!item;
}

export function sortByOrdering(a, b) {
  if (parseFloat(a.ordering) < parseFloat(b.ordering)) {
    return 1;
  }
  if (parseFloat(a.ordering) > parseFloat(b.ordering)) {
    return -1;
  }
  return 0;
}

export function htmlParse(value?: string) {
  if (!value) {
    return '';
  }
  if (value && typeof value === 'string') {
    try {
      return parse(value) ?? '';
    } catch {
      return null;
    }
  } else if (typeof value === 'string') {
    return value;
  }
}

export function isNullObject(obj) {
  for (let key in obj) {
    if (hasValue(obj[key])) {
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        if (!isNullObject(obj[key])) {
          return false;
        }
      } else {
        return false;
      }
    }
  }
  return true;
}

export function encodeData(data) {
  if (typeof data === 'object') {
    return encodeURI(JSON.stringify(data));
  }
  return encodeURI(data);
}

export function isImage(input) {
  return input ? input.match(/\.(jpg|jpeg|png|gif)$/i) : false;
}

export function isInTime(date) {
  if (+date < 0) {
    return true;
  }
  if (date === 0 || date === '0') {
    return false;
  }
  const now = new Date().getTime();
  if (date) {
    const unitDate = getUnitTime(date);
    return unitDate >= now;
  }
  return false;
}

export function getUnitTime(timestamp) {
  if (Math.abs(+timestamp) < 10000000000) {
    return +timestamp * 1000;
  } else {
    return +timestamp;
  }
}

export function setUnitTime(timestamp) {
  if (Math.abs(+timestamp) < 10000000000) {
    return +timestamp;
  } else {
    return Math.round(+timestamp / 1000);
  }
}

export function cleanTags(strInputCode) {
  return strInputCode ? strInputCode.replace(/<\/?[^>]+(>|$)/g, '') : '';
}

export function toShortText(input: string, len: number) {
  return input?.length > len ? `${input.substring(0, len)}...` : input;
}

//calc = "calc(150 * var(--gn-divider-meter) * var(--gn-unit))"
export function getCssCalcValue(calc) {
  const tempElement = document.createElement('div');
  tempElement.style.width = calc;
  document.body.appendChild(tempElement);
  const computedWidth = window.getComputedStyle(tempElement).width;
  document.body.removeChild(tempElement);
  if (computedWidth.includes('px')) {
    let [split] = computedWidth.split('px');
    return +split;
  }
  return computedWidth;
}

export function handleImgRatio({ width, imageRatio }) {
  if (width) {
    return width * Number(imageRatio);
  }
}

export function getDirection() {
  const root = document.getElementById('root');
  if (root) {
    if (root?.classList.contains('rtl')) {
      return 'rtl';
    }
    if (root?.classList.contains('ltr')) {
      return 'ltr';
    }
  }
}

function compareBooleanValues(value1, value2) {
  if (typeof value1 === 'string' && typeof value2 === 'boolean') {
    if (value1.toLowerCase() === 'true' && value2 === true) {
      return true;
    } else if (value1.toLowerCase() === 'false' && value2 === false) {
      return true;
    }
  }
  return false;
}

export function getUnitPrice({ price }) {
  const savedCurrency = Storage.getStorage({ key: 'currency' });
  const defaultCurrency = _Params?.currency;
  if (!savedCurrency || savedCurrency === defaultCurrency?.ID) {
    return price;
  }
  const currencyList = jsonParse(_Params?.currencyList);
  let currentCurrency;
  for (let i in currencyList) {
    if (savedCurrency === currencyList[i]?.ID) {
      currentCurrency = currencyList[i];
      break;
    }
  }
  const newPrice = +price * (+currentCurrency?.grade / +defaultCurrency?.grade);
  const pow = +currentCurrency?.decimalPlaces;
  return Math.ceil(newPrice * Math.pow(10, pow)) / Math.pow(10, pow);
}

export function getUnitCurrency() {
  const savedCurrency = Storage.getStorage({ key: 'currency' });
  const defaultCurrency = _Params?.currency;
  if (!savedCurrency || savedCurrency === defaultCurrency?.ID) {
    return _Params?.currency?.symbol || Trn({ text: 'price_unit' });
  }
  const currencyList = jsonParse(_Params?.currencyList);
  let currentCurrency;
  for (let i in currencyList) {
    if (savedCurrency === currencyList[i]?.ID) {
      currentCurrency = currencyList[i];
      break;
    }
  }
  return currentCurrency?.symbol;
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function isNull(data) {
  if (Array.isArray(data)) {
    return !data.length;
  }
  if (data && typeof data === 'object') {
    return !Object.keys(data).length;
  }
  //برای چک onSale اضافه شد
  if (data === 0 || data === false) {
    return false;
  }
  return !data;
}

export function convertRouteToCls(location) {
  const { app, view } = parseURL({ path: location });
  if (app && view) {
    const capitalizedView = view.charAt(0).toUpperCase() + view.slice(1);
    return app + capitalizedView;
  }
  return '/';
}
